import React from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Autocomplete,
} from "@mui/material";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { applyLeave } from "../../services/leaveService"; // Your service
import BasicModal from "../../components/BasicModal";
import FormModalActions from "../../components/FormModalActions";
import {
  DENSE_FIELD_PROPS,
  DENSE_FORM_BODY_SX,
  FORM_MODAL_CONTENT_SX,
} from "../../utils/formModalStyles";
import { useSelector } from 'react-redux'; // Import useSelector
import { getDoctorByUserId } from "../../services/doctorService"; // Import the service
import { getStaffByUserId } from "../../services/StaffService"; // Import the service

const validationSchema = Yup.object({
  leaveType: Yup.string().required("Leave Type is required"),
  leaveReason: Yup.string().required("Reason is required"),
});

const ApplyLeaveEditModal = ({ open, onClose, attendanceInfo }) => {
  // const attendanceDate = attendanceInfo.attendanceDate; // Extract attendanceDate from attendanceInfo
  // console.log("Attendance Date in Modal: ", attendanceDate); // Log the attendance date
  
  const user = useSelector((state) => state.user.user); // Access user from Redux
  const formik = useFormik({
    initialValues: {
      // leaveFromDate: dayjs(attendanceDate), // Set leaveFromDate to attendanceDate
      // leaveToDate: dayjs(attendanceDate),   // Set leaveToDate to attendanceDate
      leaveType: "",
      leaveReason: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
              // Fetch user details based on user.id
                let userDetails;
                if (user.roleName === "doctor" || user.roleName === "surgeon") {
                  userDetails = await getDoctorByUserId(user.id); // Fetch doctor details
                } else {
                  userDetails = await getStaffByUserId(user.id); // Fetch staff details
                }

        const payload = {
          // attendanceDate: values.leaveFromDate.format("YYYY-MM-DD"), // Set attendance date
          // leaveFromDate: values.leaveFromDate.format("YYYY-MM-DD"), // Map to leaveFromDate
          // leaveToDate: values.leaveToDate.format("YYYY-MM-DD"),     // Map to leaveToDate
          attendanceDate: attendanceInfo.attendanceDate, // Set attendance date
          leaveFromDate: attendanceInfo.attendanceDate, // Map to leaveFromDate
          leaveToDate: attendanceInfo.attendanceDate,     // Map to leaveToDate
          leaveType: values.leaveType,
          leaveReason: values.leaveReason,
          ...(user?.roleName === 'doctor' 
            ? { doctorId: userDetails.id }  // Use fetched doctor ID
            : { staffId: userDetails.id }   // Use fetched staff ID
          )
        };

        await applyLeave(payload);
        alert("Leave applied successfully!");
        handleCloseModalState();
      } catch (error) {
        console.error("Apply leave error:", error);
        alert("Failed to apply for leave.");
      }
    },
  });

  const handleCloseModalState = () => {
    onClose();
    formik.resetForm();
  };

  return (
    <BasicModal
      open={open}
      onClose={handleCloseModalState}
      title="Apply Leave"
    >
      <Box sx={{ ...FORM_MODAL_CONTENT_SX, ...DENSE_FORM_BODY_SX }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
              {/* <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From Date"
                    value={formik.values.leaveFromDate}
                    onChange={(value) => formik.setFieldValue("leaveFromDate", value)}
                    disabled // Keep the field disabled
                    slotProps={{
                      textField: {
                        fullWidth: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid> */}

              <Grid item xs={12} md={6}>
                <TextField
                  label="From Date"
                  type="date"
                  name="leaveFromDate"
                  value={attendanceInfo.attendanceDate}
                  disabled
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  {...DENSE_FIELD_PROPS}
                />
              </Grid>

              {/* <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To Date"
                    value={formik.values.leaveToDate}
                    onChange={(value) => formik.setFieldValue("leaveToDate", value)}
                    disabled // Keep the field disabled
                    slotProps={{
                      textField: {
                        fullWidth: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid> */}

              <Grid item xs={12} md={6}>
                <TextField
                  label="To Date"
                  type="date"
                  name="leaveToDate"
                  value={attendanceInfo.attendanceDate}
                  disabled
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  {...DENSE_FIELD_PROPS}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Autocomplete
                  options={[
                    "Casual Leave (CL)",
                    "Sick Leave (SL)",
                    "Earned Leave / Privilege Leave (EL/PL)",
                    "Maternity Leave",
                    "Paternity Leave",
                    "Marriage Leave",
                    "Unpaid Leave / Leave Without Pay (LWP)",
                    "Sabbatical Leave",
                  ]}
                  value={formik.values.leaveType}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("leaveType", newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Leave Type"
                      error={formik.touched.leaveType && Boolean(formik.errors.leaveType)}
                      helperText={formik.touched.leaveType && formik.errors.leaveType}
                      {...DENSE_FIELD_PROPS}
                    />
                  )}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="leaveReason"
                  name="leaveReason"
                  label="Leave Reason"
                  value={formik.values.leaveReason}
                  onChange={formik.handleChange}
                  error={formik.touched.leaveReason && Boolean(formik.errors.leaveReason)}
                  helperText={formik.touched.leaveReason && formik.errors.leaveReason}
                  {...DENSE_FIELD_PROPS}
                />
              </Grid>

              <Grid item xs={12}>
                <FormModalActions
                  onCancel={handleCloseModalState}
                  submitType="submit"
                  submitDisabled={formik.isSubmitting}
                  loading={formik.isSubmitting}
                />
              </Grid>
          </Grid>
        </form>
      </Box>
    </BasicModal>
  );
};

export default ApplyLeaveEditModal;
